import { withDependencies } from '@wix/thunderbolt-ioc'
import { TpaPopupApiSymbol } from '../symbols'
import type { IPageDidMountHandler, ITpaPopup } from '@wix/thunderbolt-symbols'
import { ITpaSrcUtility, TpaSrcUtilitySymbol } from 'feature-tpa-commons'

export const TpaPopupDsFactory = withDependencies(
	[TpaPopupApiSymbol, TpaSrcUtilitySymbol],
	(tpaPopupApi: ITpaPopup, tpaSrcUtility: ITpaSrcUtility): IPageDidMountHandler => {
		return {
			pageDidMount(pageId) {
				tpaSrcUtility.registerPopupControls(pageId, { refreshAllPopups: tpaPopupApi.refreshAllPopups })
				return () => {
					tpaPopupApi.closeNonPersistentPopups()
				}
			},
		}
	}
)
